import type { SubCustomer } from '../domain/types'
import type { SubCustomerDto } from './api-types'

export function transformDtoToDomain(dto: SubCustomerDto): SubCustomer {
  return {
    id: String(dto.id),
    documentId: dto.documentId,
    code: dto.code,
    name: dto.name,
    phone: dto.phone ?? null,
    tenant: dto.tenant
      ? {
          id: String(dto.tenant.id ?? dto.tenant.documentId ?? ''),
          documentId: String(dto.tenant.documentId ?? dto.tenant.id ?? ''),
          name: dto.tenant.name,
          code: dto.tenant.code ?? '',
        }
      : null,
    createdAt: dto.createdAt,
    updatedAt: dto.updatedAt,
  }
}
